import type {TuiLanguageLayout} from '@taiga-ui/i18n/types';

export const TUI_ENGLISH_LANGUAGE_LAYOUT: TuiLanguageLayout = {
    inputSearch: {
        popular: 'Popular',
        history: 'Recent',
        placeholder: 'Type query',
        hotkey: 'to search',
        all: 'All',
        empty: 'Nothing found',
    },
};
